import { API } from "./axiosInstance"

/**
 * Calls the get userPublicKeys endpoint
 * @returns the public keys
 */
export const getUserPublicKeys = async () => {
    const publicKeys = await API.get(`/userPublicKeys`);
    return publicKeys.data;
}

/**
 * Calls the put userPublicKeys endpoint
 * @param {*} userPublicKey the new userPublicKey object
 * @param {*} staticId the id of the userPublicKey to update
 * @returns the response from usermanagement-service
 */
export const updateUserPublicKey = async (userPublicKey, staticId) => {
    const response = await API.put(`/userPublicKeys/${staticId}`, userPublicKey);
    return response.data;
}

/**
 * Calls the post userPublicKeys endpoint
 * @param {*} userPublicKey the userPublicKey to create
 * @returns the response from usermanagement-service
 */
export const createUserPublicKey = async (publicKey) => {
    const response = await API.post(`/userPublicKeys`, publicKey);
    return response.data;
}

/**
 * Calls the delete userPublicKeys endpoint
 * @param {*} staticId the userPublicKey to delete
 * @returns the response from usermanagement-service
 */
export const deleteUserPublicKey = async (staticId) => {
    const response = await API.delete(`/userPublicKeys/${staticId}`);
    return response.data;
}